<button
  class="cursor-pointer flex items-center justify-center"
  [type]="type"
  [disabled]="disabled"
  [ngClass]="getButtonClasses()"
  [style.max-height]="maxHeight"
  (click)="handleClick()">
  @if (iconName) {
    <app-icon [name]="iconName" [size]="18"></app-icon>
  }
  @if (iconNameV2) {
    <app-icon-v2 [name]="iconNameV2" [size]="18"></app-icon-v2>
  }
  <ng-content></ng-content>
</button>
